// ===== mathUtils.js =====

// شمارش تعداد رقم اعشار (حتی برای فرمت علمی)
export function countDecimals(value) {
    if (!isFinite(value)) return 0;
    const valueStr = String(value);
    if (valueStr.indexOf('e') >= 0) {
        const parts = valueStr.split('e');
        const decPart = (parts[0].split('.')[1] || '').length;
        const exp = parseInt(parts[1], 10);
        return Math.max(0, decPart - exp);
    }
    const idx = valueStr.indexOf('.');
    return idx >= 0 ? valueStr.length - idx - 1 : 0;
}

// ضرب امن: دو عدد اعشاری را به عدد صحیح تبدیل می‌کند و بعد تقسیم می‌کند
export function safeMultiply(a, b, roundPrecision = 6) {
    a = Number(a) || 0;
    b = Number(b) || 0;

    const da = countDecimals(a);
    const db = countDecimals(b);

    console.log(da," ",db)
    const intA = Math.round(a * Math.pow(10, da));
    const intB = Math.round(b * Math.pow(10, db));

    const result = (intA * intB) / Math.pow(10, da + db);

    // گرد کردن نهایی برای جلوگیری از خطاهای ریز شناور
    return Number(result.toFixed(roundPrecision));
}

// جمع امن (درصورت نیاز)
export function safeAdd(a, b, roundPrecision = 6) {
    console.log("safeAdd: ",a," ",b)
    const res = (Number(a) || 0) + (Number(b) || 0);
    return Number(res.toFixed(roundPrecision));
}
